import { watch } from 'vue';
import { useMarketWatchlist } from '@/composables/useMarketWatchlist.js';

const SYNC_DEBOUNCE_MS = 400;
let syncTimer = null;

/**
 * page 接口不可用时，对 Feed 可见 collectionId 批量 check 恢复收藏图标
 * @param {() => string[]} getCollectionIds
 */
export function useFeedFavoriteSync(getCollectionIds) {
  const { syncFavoriteChecks, pageApiUnavailable } = useMarketWatchlist();

  watch(
    [() => getCollectionIds(), pageApiUnavailable],
    ([ids, unavailable]) => {
      if (!unavailable) return;
      clearTimeout(syncTimer);
      syncTimer = setTimeout(() => {
        syncFavoriteChecks(Array.isArray(ids) ? ids : []);
      }, SYNC_DEBOUNCE_MS);
    },
    { immediate: true }
  );
}
